import * as React from "react";
type Props = {
  className?: string,
};
function SvgSimplifyCooking({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-SimplifyCooking"
      className={className}
    >
      <path
        d="M13.2168 23.829C13.1546 23.7159 13.0674 23.5151 12.6624 23.3486C11.5059 22.8733 10.4481 22.6472 9.19892 22.1022C8.23772 21.6828 7.45042 21.1552 6.41607 20.7383C5.3511 20.3089 4.30362 20.0294 3.64582 20.7786C3.3296 21.1388 2.32355 22.5497 2.5269 23.5731C2.59833 23.9327 2.98211 24.5923 3.92515 24.8195C4.9533 25.0673 6.35411 25.1212 7.83648 25.8613C8.42873 26.157 9.23187 26.524 10.1486 27.0333C10.7278 27.3287 11.1004 27.2785 11.2957 27.2006C11.8105 26.9953 12.1713 26.1124 12.5225 25.5731C12.8651 25.0468 13.5137 24.3677 13.2168 23.829Z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.8898 13.5427C42.6471 15.115 41.5345 14.7286 41.2917 16.301C41.0489 17.8736 42.1614 18.26 41.9186 19.8326C41.6757 21.4056 40.5632 21.0191 40.3203 22.5922"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.3743 10C38.1315 11.5724 37.0189 11.186 36.7761 12.7583C36.5333 14.3309 37.6459 14.7173 37.403 16.2899C37.1602 17.863 36.0476 17.4765 35.8047 19.0495"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.47 11.1808C32.2272 12.7532 31.1146 12.3668 30.8718 13.9392C30.629 15.5118 31.7416 15.8982 31.4987 17.4707C31.2559 19.0438 30.1433 18.6573 29.9004 20.2304"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.3811 29.6462C31.0308 29.803 31.7206 29.9626 32.4644 30.1249C32.4644 30.1249 42.9668 32.4759 46.2425 31.2205C46.3758 31.1317 46.4703 31.0325 46.4931 30.9151C46.7155 29.7602 41.2687 27.646 34.3271 26.1931C27.3855 24.7401 21.5777 24.4985 21.3552 25.6534C21.1676 26.6267 25.0136 28.2803 30.3811 29.6462Z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.3823 31.1019C46.3426 31.1432 46.2987 31.1834 46.2431 31.2205C42.9674 32.4759 32.465 30.1251 32.465 30.1251C31.7212 29.9626 31.0314 29.8032 30.3816 29.6463C25.0547 28.2906 21.2311 26.6524 21.3571 25.6763C21.3477 25.6725 21.3377 25.6688 21.3283 25.6649C21.1784 25.9941 21.0542 26.3341 20.988 26.6959C20.5471 29.1017 22.135 31.6583 24.9371 33.6647C25.06 33.7882 25.2532 33.9221 25.5086 34.0637C27.376 35.2798 29.7067 36.2574 32.306 36.8168C39.3044 38.3232 45.5847 36.2338 46.3328 32.1505C46.3961 31.8037 46.4014 31.4531 46.3823 31.1019Z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.7773 25.942L21.0436 28.8942"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export default SvgSimplifyCooking;
